export default {
    "fr": {
        "Comment": "Commentaire",
        "Email": "Email",
        "Password": "Mot de passe",
        "Name": "Nom",
        "Firstname": "Prénom",
        "Lastname": "Nom",
        "Phone": "Téléphone",
        "Subject": "Objet",
        "Message": "Message",
        "Feedback default message": "Merci pour votre demande. Nous reviendrons vers vous d'ici peu.",
        "Send": "Envoyer"
    },
    "en": {
        "Email": "Email",
        "Password": "Mot de passe",
        "Firstname": "Firstname",
        "Lastname": "Lastname",
        "Phone": "Phone",
        "Subject": "Subject",
        "Message": "Message",
        "Send": "Envoyer"
    }
}
